import { AddRounded, DeleteRounded } from '@mui/icons-material';
import {
    Card,
    CardActionArea,
    CardContent,
    Fab,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Screen from '../../components/fragments/Screen';
import { removeFromLocalList } from '../../store/slices/localSlice';

export default function StudyReminderScreen() {
    const navigate = useNavigate();
    const state = useSelector((st) => st);

    const { reminders } = state.local;

    return (
        <Screen authPass title={'Study Reminders'}>
            <Fab style={{ position: 'fixed', bottom: 16, right: 16 }}>
                <AddRounded
                    onClick={() => navigate('/bible-tools/study-reminder-add')}
                />
            </Fab>
            {reminders?.map((reminder) => (
                <ReminderCard key={reminder.id} reminder={reminder} />
            ))}
        </Screen>
    );
}

const ReminderCard = ({ reminder }) => {
    const [marked, setMarked] = useState(false);
    const dispatch = useDispatch();

    return (
        <Grid item xs={12}>
            <Card variant="outlined" className="h-100">
                <CardActionArea
                    onClick={() => setMarked(!marked)}
                    className="h-100"
                >
                    <CardContent className="d-flex align-items-center  justify-content-between">
                        <div>
                            <Typography className="fw-bold">
                                {reminder?.title}
                            </Typography>
                            <Typography>{reminder.reminder}</Typography>
                            <div className="d-flex">
                                <Typography className="me-2" color="primary">
                                    {moment(reminder.date).format('DD MMM')}
                                </Typography>
                                <Typography color="primary">
                                    {reminder.time}
                                </Typography>
                            </div>
                            <Typography color="textSecondary">
                                {moment(reminder.id).fromNow()}
                            </Typography>
                        </div>
                        {marked && (
                            <IconButton
                                onClick={() => {
                                    dispatch(
                                        removeFromLocalList({
                                            id: reminder.id,
                                            list: 'reminders',
                                        })
                                    );
                                }}
                            >
                                <DeleteRounded />
                            </IconButton>
                        )}
                    </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    );
};
